import { getPrivateDispensaryServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';

export const getServerSideProps = getPrivateDispensaryServerSideProps;
export { ConciergePage as default } from 'src/concierge';
